import React, { memo } from 'react'

type ColumnM60Type = {
  children: React.ReactNode
  customstyle?: string
}

export const ColumnM60Service: React.FC<ColumnM60Type> = memo(
  ({ children, customstyle }) => {
    return (
      <div
        className={`mt-[1.5rem] lg:mt-[3.5rem] flex flex-wrap justify-between gap-6 lg:gap-8 w-full ${customstyle}`}
      >
        {children}
      </div>
    )
  }
)

ColumnM60Service.displayName = 'ColumnM60Service'
